import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Divider,
} from 'antd';
import { bindActionCreators } from 'redux';
import { Box, ShowIf, Text } from '../../shared/components';
import { ArticulosReposicionType } from '../types/newCo.types';
import { AllSelection, MultipleSelection } from '../constants/selectionTypes.constants';
import {
  comprobarArticulosReposicionesStock, generarCsvArticulos, generarPedidoGw1, getArticulosReposiciones,
  iniciarModuloReposiciones, setFilter, setPaginationReposicion,
  setSelectedArticulosReposicion, setUnidadesArticuloReposicion,
} from '../../../state/actions/creators/newCo.reposiciones.actioncreator';
import ReposicionesHeader from '../containers/ReposicionesHeader';
import FiltersContainer from '../containers/FiltersContainer';
import SearchContainer from '../containers/SearchContainer';
import Page from '../../shared/components/layout/Page.layout';
import EditableTable from '../../shared/containers/EditableTable';
import SearchTextComponent from '../components/SearchTextComponent';

const editableStyles = `
    .editable-cell {
      position: relative;
    }
    .editable-cell-value-wrap {
      padding: 8px 8px;
      cursor: pointer;
    }
    .editable-row:hover .editable-cell-value-wrap {
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 7px 7px;
    }
    .ant-table-bordered .ant-table-tbody td {
      padding: 8px 8px;
    }
    .ant-card-head{
      border-bottom: 0;
      padding: 0 16px;
    }
    .ant-card-body {
      padding: 0 16px 16px 16px;
    }
`;

class ReposicionesPage extends React.Component {
  componentDidMount() {
    const { iniciarModuloReposiciones, tiendaTrabajo } = this.props;
    iniciarModuloReposiciones({ tipoArticulo: 3, tienda: tiendaTrabajo, proveedor: null });
  }

  onSelectChange(record, selected, selectedRows) {
    const { selection: { type, rowSelection }, setSelectedArticulosReposicion } = this.props;
    const selection = [...rowSelection];
    if (type === MultipleSelection) {
      if (record) {
        setSelectedArticulosReposicion(type, record, selected);
      } else {
        setSelectedArticulosReposicion(AllSelection, []);
      }
    }
    if (type === AllSelection) {
      if (record) {
        if (selected) {
          selection.delete(record);
        } else {
          selection.push(record);
        }
        setSelectedArticulosReposicion(type, record, selected);
      } else {
        setSelectedArticulosReposicion(MultipleSelection, []);
      }
    }
  }

  onHandleUnidadesChange({ rowKey, newRow }) {
    const { setUnidadesArticuloReposicion } = this.props;
    const unidades = newRow.unidadesPropuestas;
    setUnidadesArticuloReposicion({ rowKey, unidades });
  }

  onTableChange({
    pagination,
  }) {
    const { setPaginationReposicion } = this.props;
    setPaginationReposicion(pagination);
  }

  render() {
    const {
      selection: { type, rowSelection: selectedData }, getArticulosReposiciones,
      articulosReposicionesData, articulosReposicionesRequestState, subtiposArticulo,
      reposicionesFilters, articulosReposicionesDataModificados, proveedores, valoresTipo,
      comprobarArticulosReposicionesStock, generarPedidoGw1, tiendas, tiposArticulo, valoresPropiedadesRequestState,
      setFilter, generarCsvArticulos, permisos,
    } = this.props;
    const proveedorSeleccionado = proveedores.find(e => e.id === reposicionesFilters.proveedor);
    const proveedorMultiopticasSeleccionado = (proveedorSeleccionado && proveedorSeleccionado.nombre === 'MULTIOPTICAS') == true;
    const columns = [
      {
        title: 'Uds',
        dataIndex: 'unidadesPropuestas',
        key: 'unidades',
        editable: true,
        required: true,
        width: '5%',
        align: 'right',
      },
      {
        title: 'Cod. Art',
        dataIndex: 'id',
        key: 'id',
        width: '10%',
        align: 'right',
      },
      {
        title: 'Familia',
        dataIndex: 'tipoStr',
        key: 'familia',
        width: '10%',
        align: 'left',
      },      
      {
        title: 'Articulos',
        dataIndex: 'descripcion',
        key: 'descripcion',
        width: '25%',
        align: 'left',
      },
      {
        title: 'Fecha Lan.',
        dataIndex: 'fechaLanzamiento',
        key: 'fechaLanzamiento',
        width: '10%',
        align: 'center',
      },
      {
        title: 'Ventas',
        dataIndex: 'unidadesVendidas',
        key: 'unidadesVendidas',
        width: '10%',
        align: 'right',
      },
      {
        title: 'Pedidas',
        dataIndex: 'pedidas',
        key: 'pedidas',
        width: '10%',
        align: 'right',
      },
      {
        title: 'Stock',
        dataIndex: 'stock',
        key: 'stock',
        width: '10%',
        defaultValue: '-',
        align: 'right',
      },
      {
        title: 'Stock Min.',
        dataIndex: 'stockMinimo',
        key: 'stockMinimo',
        width: '10%',
        defaultValue: '-',
        align: 'right',
      }
    ];
    // if (proveedorMultiopticasSeleccionado) {
    //   columns.push({
    //     title: 'Stock',
    //     dataIndex: 'stock',
    //     key: 'stock',
    //     width: '10%',
    //     defaultValue: '-',
    //     align: 'center',
    //   });
    // }
    const selectedRowKeys = type === MultipleSelection ? selectedData : articulosReposicionesData.datos.filter(e => !selectedData.map(e => e.id).includes(e.id));
    const rowSelection = {
      columnTitle: selectedRowKeys.length > 0 ? <div>{selectedRowKeys.length}</div> : <></>,
      selectedRowKeys: selectedRowKeys ? selectedRowKeys.map(e => e.id) : [],
      onSelect: (record, selected, selectedRows) => this.onSelectChange(record, selected, selectedRows),
      onSelectAll: (selected, selectedRows) => this.onSelectChange(null, selected, selectedRows),
    };
    const inIframe = window.top != window.self;

    return (
      <Page
        titulo={inIframe ? null : 'Artículos pendientes de pedir'}
        // overrideMaxWidth={inIframe ? '100%' : undefined}
        overrideMaxWidth={'100%'}
        style={{maxWidth: 'none !important'}}
        hasStickyActionsHeader
        navigationItems={inIframe ? null : [
          {
            node: <Text translationId="navegacion.home" />,
            link: '',
          },
          {
            node: <Text translationId="navegacion.almacen" />,
          },
        ]}
      >
        <ReposicionesHeader inIframe={inIframe} proveedorMultiopticasSeleccionado={proveedorMultiopticasSeleccionado} permisos={permisos} onGenerarCsv={generarCsvArticulos} onComprobarStock={comprobarArticulosReposicionesStock} onGenerarPedido={generarPedidoGw1} />
        <style>{editableStyles}</style>
        <Box>
          <SearchContainer
            onFilterSelect={setFilter}
            onSearchClick={getArticulosReposiciones}
            filters={{ tipoArticulo: reposicionesFilters.tipoArticulo, tienda: reposicionesFilters.tienda, proveedor: reposicionesFilters.proveedor }}
            values={{ tiposArticulo, tiendas, proveedores }}
          />
          <Divider style={{ margin: 0, top: 0 }} />
          <ShowIf condition={reposicionesFilters.tipoArticulo !== -1}>
            <FiltersContainer
              capitalize
              onFilterSelect={setFilter}
              filters={reposicionesFilters.propiedades}
              labels={subtiposArticulo.filter(e => e.tipo.id === reposicionesFilters.tipoArticulo)}
              values={valoresTipo}
              loading={valoresPropiedadesRequestState.running}
              loaded={valoresPropiedadesRequestState.success}
            />
            <Divider style={{ margin: 0, top: 0 }} />
          </ShowIf>
          <SearchTextComponent text={reposicionesFilters.searchText} />
          <Divider style={{ margin: 0, top: 0 }} />
          <EditableTable
            bordered={false}
            loading={articulosReposicionesRequestState.running}
            columns={columns}
            dataSource={articulosReposicionesData.datos}
            changedDataSource={articulosReposicionesDataModificados}
            total={articulosReposicionesData.total}
            rowSelection={rowSelection}
            onRowChange={data => this.onHandleUnidadesChange(data)}
            onChange={(pagination, filters, sorter, extra) => this.onTableChange({
              pagination, filters, sorter, extra,
            })}
            pagination={reposicionesFilters.pagination}
          />
        </Box>
      </Page>
    );
  }
}
const mapStateToProps = ({
  core, newCoReposiciones, sagas, auth,
}) => ({
  tiendaTrabajo: auth.user.tienda_id,
  permisos: auth.permisos,
  tiendas: core.tiendas,
  tiposArticulo: core.tiposArticulo,
  subtiposArticulo: core.subtiposArticulo,
  proveedores: newCoReposiciones.proveedores,
  valoresTipo: newCoReposiciones.valoresTipo,
  selection: newCoReposiciones.selection,
  articulosReposicionesData: newCoReposiciones.articulosReposicionesData,
  articulosReposicionesDataModificados: newCoReposiciones.articulosReposicionesDataModificados,
  reposicionesFilters: newCoReposiciones.filters,
  articulosReposicionesRequestState: sagas.GET_ARTICULOS_REPOSICIONES,
  valoresPropiedadesRequestState: sagas.GET_VALORES_PROPIEDADES_ARTICULOS,
});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setSelectedArticulosReposicion,
    iniciarModuloReposiciones,
    setPaginationReposicion,
    setUnidadesArticuloReposicion,
    comprobarArticulosReposicionesStock,
    getArticulosReposiciones,
    generarPedidoGw1,
    generarCsvArticulos,
    setFilter,
  }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReposicionesPage);

ReposicionesPage.propTypes = {
  permisos: PropTypes.shape({ configuracion: PropTypes.shape({}), empresa: PropTypes.shape({}) }).isRequired,
  tiendaTrabajo: PropTypes.number,
  articulosReposicionesRequestState: PropTypes.shape({ success: PropTypes.bool, running: PropTypes.bool }),
  valoresPropiedadesRequestState: PropTypes.shape({ success: PropTypes.bool, running: PropTypes.bool }),
  selection: PropTypes.shape({
    type: PropTypes.string,
    rowSelection: PropTypes.arrayOf(ArticulosReposicionType),
  }).isRequired,
  articulosReposicionesData: PropTypes.shape({ datos: PropTypes.arrayOf(ArticulosReposicionType), total: PropTypes.number }),
  articulosReposicionesDataModificados: PropTypes.shape({ datos: PropTypes.arrayOf(ArticulosReposicionType), total: PropTypes.number }),
  reposicionesFilters: PropTypes.shape({
    pagination: PropTypes.shape({
      page: PropTypes.number, pageSize: PropTypes.number,
    }),
    tipoArticulo: PropTypes.number,
    searchText: PropTypes.string,
    tienda: PropTypes.number,
    proveedor: PropTypes.number,
    propiedades: PropTypes.shape({}),
  }),
  subtiposArticulo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  valoresTipo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setSelectedArticulosReposicion: PropTypes.func.isRequired,
  setPaginationReposicion: PropTypes.func.isRequired,
  iniciarModuloReposiciones: PropTypes.func.isRequired,
  getArticulosReposiciones: PropTypes.func.isRequired,
  setUnidadesArticuloReposicion: PropTypes.func.isRequired,
  generarPedidoGw1: PropTypes.func.isRequired,
  generarCsvArticulos: PropTypes.func.isRequired,
  comprobarArticulosReposicionesStock: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
};
ReposicionesPage.defaultProps = {
  tiendaTrabajo: 0,
  articulosReposicionesData: [],
  articulosReposicionesDataModificados: [],
  reposicionesFilters: { pagination: { page: 1, pageSize: 8 } },
  articulosReposicionesRequestState: { running: false, success: false },
  valoresPropiedadesRequestState: { running: false, success: false },
};
